module.exports = __webpack_public_path__ + "img/d1.3e859873.png";